const loadingMessages = [
  "Initializing ARC Reactor...",
  "Stabilizing power core...",
  "Loading GitHub repositories...",
  "Loading LinkedIn profile...",
  "Compiling response..."
];

export default loadingMessages;